module.exports = "/_next/static/images/tor-25191b6f9f88af6ace0f3c4b54c60a30.svg";